/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {HeaderMenuIcon} from './HeaderMenuIcon'
import {useAuth, getUserData, isAdmin, isSuperAdmin} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {Modal} from 'react-bootstrap'
import GuidelineModal from '../../../../app/pages/utils/GuidelineModal'
import GuidelineViewOnlyModal from '../../../../app/pages/utils/GuidelineViewOnlyModal'
import * as API from '../../../../app/api'
import NPSSurvey from '../../../../app/pages/nps/NPSSurvey'
import {ProfileHeader} from '../../../../app/modules/profile/ProfileHeader'
import {useUsermenuData} from '../../../../app/hooks/useUserMenuData'
const NPS_DISMISSAL_DURATION_MS = 7 * 24 * 60 * 60 * 1000

const getNPSDismissalKey = (surveyId: string) => {
  const userGuid = getUserData()?.guid || 'unknown-user'
  return `nps:dismissed-until:${userGuid}:${surveyId}`
}

const isNPSDismissed = (surveyId: string) => {
  try {
    const dismissedUntil = Number(localStorage.getItem(getNPSDismissalKey(surveyId)))
    return Number.isFinite(dismissedUntil) && dismissedUntil > Date.now()
  } catch (_) {
    return false
  }
}

const HeaderUserMenu: FC = () => {
  const {logout} = useAuth()
  const {isFetching, isLojistasOnly} = useUsermenuData()
  const [modalGuidelines, showModalGuidelines] = useState<boolean>(false)
  const [modalGuidelinesViewOnly, showModalGuidelinesViewOnly] = useState<boolean>(false)
  const [modalNPS, showModalNPS] = useState<boolean>(false)
  const [guidelines, setGuidelines] = useState<any>(null)
  const [idSurvey, setIdSurvey] = useState<any>(null)
  const [survey, setSurvey] = useState<any>(null)
  const [modalProfile, showModalProfile] = useState(false)
  const [, refreshProfileSummary] = useState(0)

  const getNPS = async () => {
    const response = await API.isSurveyAvailable()
    if (response.success && response.data?.id_survey) {
      if (isNPSDismissed(response.data.id_survey)) return
      setSurvey(response.data)
      setIdSurvey(response.data.id_survey)
      showModalNPS(true)
    }
  }

  const closeNPS = () => {
    if (idSurvey) {
      try {
        const dismissedUntil = Date.now() + NPS_DISMISSAL_DURATION_MS
        localStorage.setItem(getNPSDismissalKey(idSurvey), dismissedUntil.toString())
      } catch (_) {}
    }
    showModalNPS(false)
  }

  const getGuidelines = async () => {
    const response = await API.getGuidelines()
    if (!response.data) return
    setGuidelines(response.data)
  }

  useEffect(() => {
    getNPS()
    getGuidelines()
  }, [])

  const onLogoutClick = (): any => {
    onMenuClick('Sair')
    logout()
  }

  const onMenuClick = (title: string): any => {
    const gtag = (window as any).gtag
    gtag?.('event', 'click', {
      event_category: 'Header',
      event_label: title,
    })
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <Modal
        id='modal_profile'
        tabIndex={-1}
        centered
        dialogClassName='profile-modal-dialog'
        show={modalProfile}
        onHide={() => showModalProfile(false)}
      >
        <ProfileHeader
          onClose={() => showModalProfile(false)}
          onProfileUpdated={() => refreshProfileSummary((current) => current + 1)}
        />
      </Modal>
      <Modal
        id='modal_message'
        tabIndex={-1}
        dialogClassName='modal-dialog modal-dialog-centered mw-1000px'
        show={modalGuidelines}
      >
        <GuidelineModal
          onClose={() => {
            showModalGuidelines(false)
          }}
        ></GuidelineModal>
      </Modal>
      <Modal
        id='modal_message'
        tabIndex={-1}
        dialogClassName='modal-dialog modal-dialog-centered mw-1000px'
        show={modalGuidelinesViewOnly}
      >
        <GuidelineViewOnlyModal
          path={guidelines?.src}
          onClose={() => {
            showModalGuidelinesViewOnly(false)
          }}
        ></GuidelineViewOnlyModal>
      </Modal>
      <Modal
        id='modal_nps'
        tabIndex={-1}
        dialogClassName='modal-dialog modal-dialog-centered mw-1000px'
        show={modalNPS}
        onHide={closeNPS}
      >
        <NPSSurvey survey={survey} onClose={closeNPS}></NPSSurvey>
      </Modal>
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img
              alt='Logo'
              src={
                getUserData().src
                  ? getUserData().src
                  : toAbsoluteUrl('/media/icons/duotune/general/gen049.svg')
              }
            />
          </div>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {getUserData()?.name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                {isSuperAdmin() ? 'Super Admin' : isAdmin() ? 'Admin' : 'Usuário'}
              </span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {getUserData()?.email}
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <button
          type='button'
          className='menu-link px-5 border-0 bg-transparent w-100 text-start'
          data-kt-menu-dismiss='true'
          onClick={() => {
            onMenuClick('Meu Perfil')
            showModalProfile(true)
          }}
        >
          <HeaderMenuIcon name='profile' />
          <span className='menu-title'>Meu Perfil</span>
        </button>
      </div>
      {getUserData()?.guidelines ? (
        <div className='menu-item px-5'>
          <div
            className='menu-link px-5'
            onClick={() => {
              onMenuClick('Termos de Uso')
              showModalGuidelinesViewOnly(true)
            }}
          >
            <HeaderMenuIcon name='terms' />
            <span className='menu-title'>Termos de uso</span>
          </div>
        </div>
      ) : null}
      {isSuperAdmin() ? (
        <>
          <div
            className='menu-item px-5'
            data-kt-menu-trigger='hover'
            data-kt-menu-placement='left-start'
            data-kt-menu-flip='bottom'
          >
            <a href='#' className='menu-link px-5'>
              <HeaderMenuIcon name='administration' />
              <span className='menu-title'>Administrativo</span>
              <span className='menu-arrow'></span>
            </a>
            <div className='menu-sub menu-sub-dropdown w-225px py-4'>
              <div className='menu-item px-3'>
                <Link to={'/users'} className='menu-link px-5' onClick={onMenuClick('Usuários')}>
                  <HeaderMenuIcon name='users' />
                  <span className='menu-title'>Usuários</span>
                </Link>
              </div>
              {isSuperAdmin() ? (
                <>
                  <div className='menu-item px-3'>
                    <Link
                      to={'/generalmenu'}
                      className='menu-link px-5'
                      onClick={onMenuClick('Menu')}
                    >
                      <HeaderMenuIcon name='menu' />
                      <span className='menu-title'>Menu</span>
                    </Link>
                  </div>
                  <div className='menu-item px-3'>
                    <Link
                      to={'/companys'}
                      className='menu-link px-5'
                      onClick={onMenuClick('Empresas')}
                    >
                      <HeaderMenuIcon name='companies' />
                      <span className='menu-title'>Empresas</span>
                    </Link>
                  </div>

                  <div className='menu-item px-3'>
                    <Link to={'/nps'} className='menu-link px-5' onClick={onMenuClick('NPS')}>
                      <HeaderMenuIcon name='nps' />
                      <span className='menu-title'>NPS</span>
                    </Link>
                  </div>

                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => showModalGuidelines(true)}
                    >
                      <HeaderMenuIcon name='terms' />
                      <span className='menu-title'>Termos de Uso</span>
                    </a>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      ) : isAdmin() && !isFetching && !isLojistasOnly ? (
        <div className='menu-item px-5'>
          <Link to={'/users'} className='menu-link px-5' onClick={onMenuClick('Usuários')}>
            <HeaderMenuIcon name='users' />
            <span className='menu-title'>Usuários</span>
          </Link>
        </div>
      ) : (
        <></>
      )}
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <a onClick={onLogoutClick} className='menu-link px-5'>
          <HeaderMenuIcon name='logout' />
          <span className='menu-title'>Sair</span>
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
